import React from 'react';
import { makeStyles, createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const CustomButtonOLDailyBlue = (props) => {
  const customTheme = theme => ({
    root: {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'none',
      color: '#ffffff',
//      color: theme.palette.getContrastText(props.themeColor[50]),
      // backgroundColor: '#00b3cd',
      background: 'linear-gradient(90deg, #006699 0%, #00a1e9 100%)',
      transition: '.3s',
      '&:hover': {
        color: '#ffffff',
        backgroundColor: 'transparent',
        opacity: '85%',
      },
    },
  })
  const ComponentName = withStyles(customTheme)(Button)
  return <ComponentName {...props} />
}
export default CustomButtonOLDailyBlue;
